
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { PlusCircle, X } from 'lucide-react';

interface TeacherSubjectsFieldsProps {
  formData: any;
  handleChange: (e: any) => void;
}

const TeacherSubjectsFields = ({ formData, handleChange }: TeacherSubjectsFieldsProps) => {
  const [newSubject, setNewSubject] = React.useState('');
  const subjects = formData.subjects || [];

  const addSubject = () => {
    if (!newSubject.trim()) return;
    
    const updatedSubjects = [...subjects, newSubject.trim()];
    handleChange({
      target: { name: 'subjects', value: updatedSubjects }
    });
    setNewSubject('');
  };

  const removeSubject = (index: number) => {
    const updatedSubjects = [...subjects];
    updatedSubjects.splice(index, 1);
    handleChange({
      target: { name: 'subjects', value: updatedSubjects }
    });
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addSubject();
    }
  };

  return (
    <div className="space-y-4">
      <Label htmlFor="subjects">Subjects & Expertise</Label>
      
      <div className="flex gap-2">
        <Input
          id="newSubject"
          value={newSubject}
          onChange={(e) => setNewSubject(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Add a subject (e.g. Mathematics, English)"
          className="flex-1"
        />
        <Button 
          type="button" 
          onClick={addSubject}
        >
          <PlusCircle className="h-4 w-4 mr-2" />
          Add
        </Button>
      </div>
      
      {subjects.length > 0 ? (
        <div className="flex flex-wrap gap-2 mt-2">
          {subjects.map((subject: string, index: number) => (
            <div 
              key={index}
              className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm flex items-center"
            >
              {subject}
              <Button 
                variant="ghost" 
                size="sm" 
                className="h-5 w-5 p-0 ml-1 hover:bg-transparent"
                onClick={() => removeSubject(index)}
              >
                <X className="h-3 w-3" />
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-sm">No subjects added yet</p>
      )}
    </div>
  );
};

export default TeacherSubjectsFields;
